import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "../../api/axios";
import { RootState } from "..";

export interface IPasswordResetPayload {
  password: string;
  resetToken: string;
}

export interface ICompleteResetState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: string;
}

const initialState: ICompleteResetState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: "",
};

export const completePasswordResetAsync = createAsyncThunk(
  "passwordReset/complete",
  async (completeResetData: IPasswordResetPayload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/auth/password/reset",
        completeResetData
      );
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      throw error;
    }
  }
);

export const passwordResetCompleteSlice = createSlice({
  name: "passwordReset/complete",
  initialState,
  reducers: {
    resetPasswordResetCompleteState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(completePasswordResetAsync.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = "";
      })
      .addCase(completePasswordResetAsync.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(completePasswordResetAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload as string;
      });
  },
});

export const { resetPasswordResetCompleteState } =
  passwordResetCompleteSlice.actions;

export const selectPasswordResetCompleteState = (state: RootState) =>
  state.passwordResetComplete;

export default passwordResetCompleteSlice.reducer;
